<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'sponsors'
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// Sponsors.vue?18ed9df1